<button mat-mini-fab class="map-control geolocation" [class]="'btn btn-info ' + styleClass()"
  [ngClass]="{'waiting': updatingGeolocState()}" disableRipple (click)=onGeolocClick($event)>

  @if (styleClass()!='permission_denied_now' && styleClass()!='permission_denied_before') {
  @if (styleClass()=='located'){
  <mat-icon>gps_fixed</mat-icon>
  }
  @else{
  <mat-icon>location_searching</mat-icon>
  }
  } @else{
  <mat-icon>gps_off</mat-icon>
  }
</button>